// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"editDesign_title__30e8f"};